import { render, staticRenderFns } from "./section-oxygen-minus-event-chart.vue?vue&type=template&id=57871701&scoped=true"
import script from "./section-oxygen-minus-event-chart.vue?vue&type=script&lang=js"
export * from "./section-oxygen-minus-event-chart.vue?vue&type=script&lang=js"
import style0 from "./section-oxygen-minus-event-chart.vue?vue&type=style&index=0&id=57871701&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57871701",
  null
  
)

export default component.exports